import { render, staticRenderFns } from "./policy-table-header-text-translations-tab.vue?vue&type=template&id=0bd6ea18"
import script from "./policy-table-header-text-translations-tab.vue?vue&type=script&lang=js"
export * from "./policy-table-header-text-translations-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports